import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Accrochage } from '../Accrochage.js';
import styles from './NotFoundPage.module.css';

/**
 * Page introuvable : le mur de la galerie, dont l'œuvre du milieu a été
 * décrochée — il reste le clou, la trace du cadre et sa cote.
 */
export function NotFoundPage(): JSX.Element {
  const { t } = useTranslation('regie');

  return (
    <div className={styles.page}>
      <div className={styles.mur}>
        <Accrochage etat="manquant" />
      </div>
      <h1 className={styles.titre}>{t('introuvable.titre')}</h1>
      <p className={styles.phrase}>{t('introuvable.phrase')}</p>
      <Link className={styles.lien} to="/">
        {t('introuvable.lien')}
      </Link>
    </div>
  );
}
